import { supabase } from './supabase';

export async function restoreSwap({ oldId, newId }) {
  // Step 1: self-supersede NEW invoice (FK satisfied, excluded from unique index)
  const { error: e1, data: s1 } = await supabase.from('invoices').update({ superseded_by: newId }).eq('id', newId).select();
  if (e1) throw new Error('Restore failed (step 1): ' + e1.message);
  if (!s1?.length) throw new Error('Restore failed (step 1): no row updated for ' + newId);
  try {
    // Step 2: reactivate OLD invoice
    const { error: e2 } = await supabase.from('invoices').update({ superseded_by: null }).eq('id', oldId);
    if (e2) throw e2;
    // Step 3: point NEW's superseded_by at OLD
    const { error: e3 } = await supabase.from('invoices').update({ superseded_by: oldId }).eq('id', newId);
    if (e3) throw e3;
    // Step 4: flip purchases
    const { error: e4a } = await supabase.from('purchases').update({ is_superseded: false }).eq('invoice_id', oldId);
    if (e4a) throw e4a;
    const { error: e4b } = await supabase.from('purchases').update({ is_superseded: true }).eq('invoice_id', newId);
    if (e4b) throw e4b;
  } catch (e) {
    // Rollback step 1: restore NEW to active
    await supabase.from('invoices').update({ superseded_by: null }).eq('id', newId);
    throw e;
  }
}
